import { BeatLoader } from 'react-spinners'
import { andTheme } from '../../../../styles/theme'
import { LoadingContent } from '../popup-styles'
import Popup from '../popup'

const LoadingPopup = () => (
  <Popup header="Loading">
    <LoadingContent>
      <BeatLoader
        size={20}
        speedMultiplier={0.7}
        color={andTheme.colours.darkRed}
        data-testid="loading-indicator"
      />
    </LoadingContent>
  </Popup>
)

export default LoadingPopup
